import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';
import dateFormat from 'dateformat';

import TextFormat from '../common/TextFormat.jsx';

const TileLine = styled.div`
    width: max-content;
`;

const TileLine1 = styled(TileLine)`
    margin-left: 1.0rem;
    margin-top: 0.75rem;
`;

const TileLine2 = styled(TileLine)`
    margin-left: 1.0rem;
    margin-bottom: 0.75rem;
    margin-top: -0.25rem;
`;

const TileComment = styled(TileLine)`
    margin: 0rem 0.5rem 0.75rem 2.25rem;
`;

const TileLine3 = styled(TileLine)`
    width: 100%;
`;

const VideoTitle = styled.div`
    display: inline-block;
    text-align: left;
    font-size: 1.75rem;
    letter-spacing: 0.25rem;
    color: #777777;    
`;

const VideoYear = styled.div`
    display: inline-block;
    text-align: left;
    font-size: 0.9rem;
    font-family: Courier;
    font-weight: bold;
    line-height: 2rem;
    margin-top: 0.25rem;
    margin-right: 1rem;
    color: #222222;
`;

const VideoMaterials = styled.div`
    font-size: 0.9rem;
    font-style: italic;
    text-align: left;
    margin-right: 1rem;
    margin-bottom: 0.75rem;
    color: #aaaaaa;
`;

const VideoComment = styled.div`
    font-size: 0.9rem;
    text-align: justify;
    color: #777777;
    max-width: 20rem;
    margin-right: 1rem;
    padding-right: 1rem;
`;

const VideoDetail = styled.div`
    font-size: 0.75rem;
    font-style: italic;
    margin-right: 1rem;
    color: #888888;
    text-align: right;
`;

const VideoCode = styled.div`
    font-family: Courier;
    font-size: 0.65rem;
    font-weight: bold;
    margin-right: 0.125rem;
    color: #222222;
    text-align: right;
    margin-top: 0.75rem;
`;

const NowPlayingWrapper = styled.div`
    text-transform: uppercase;
    width: 100%;
`;

const NowPlayingText = styled.div`
    text-align: left;
    font-size: 0.75rem;
    color: #999999;
    margin-top: 0.25rem;
    margin-left: 1rem;
    font-weight: bold;
    text-decoration: underline;
`;

const UpNextWrapper = styled.div`
    text-transform: uppercase;
    width: 100%;
    margin-bottom: 0.5rem;
`;

const UpNextText = styled.div`
    text-align: left;
    font-size: 0.75rem;
    color: #999999;
    text-transform: uppercase;
    margin-top: 0.25rem;
    font-weight: bold;
    margin-left: 1rem;
    text-decoration: underline;
`;

const InfoBlock = styled.div`
    background-color: white;
    border: 0.15rem solid #bbbbbb;
    border-left: 0;
    width: max-content;
    box-shadow: 0.25rem 0.75rem 1.5rem #dddddd;
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
`;

const DetailsWrapper = styled.div`
    margin-top: 1rem;
`;

export class VideoInfoBlock extends Component {

    static propTypes = {
        video_item: PropTypes.object.isRequired,
        on_reference_click: PropTypes.func.isRequired,
        references: PropTypes.object.isRequired
    }

    render() {
        const {video_item, references, on_reference_click} = this.props;

        const video_title = <TileLine1>
            <VideoTitle>{video_item.title.value}</VideoTitle>
            <VideoYear>({video_item.year.value})</VideoYear>
        </TileLine1>
        const video_materials = <TileLine2>
            <VideoMaterials>{video_item.materials.value}</VideoMaterials>
        </TileLine2>

        let video_comment = [];
        if (video_item.comments && video_item.comments.items) {
            const comments = video_item.comments.items;
            const keys = Object.keys(comments).sort((a, b) => comments[a].index - comments[b].index);
            for (let k = 0; k < keys.length; k++) {
                const formatted = <TextFormat
                    text={comments[keys[k]].value} is_first={true} of_many={false}
                    references={references} on_reference_click={on_reference_click}/>
                video_comment.push(<TileComment key={k}> <VideoComment>{formatted}</VideoComment> </TileComment>);
            }
        }

        const video_venue = !video_item['venue'] ? '' :
            <TileLine3><VideoDetail>{video_item.venue.value.toLowerCase()}</VideoDetail></TileLine3>
        const video_location = !video_item['location'] ? '' :
            <TileLine3><VideoDetail>{video_item.location.value.toLowerCase()}</VideoDetail></TileLine3>
        const video_date = !video_item['date'] ? '' :
            <TileLine3><VideoDetail>{dateFormat(Date.parse(video_item.date.value), "dS mmmm yyyy").toLowerCase()}</VideoDetail></TileLine3>
        const video_code = !video_item['code'] ? '' :
            <TileLine3><VideoCode>{video_item.code.value}</VideoCode></TileLine3>

        const now_playing = <NowPlayingWrapper><NowPlayingText>now playing</NowPlayingText></NowPlayingWrapper>;
        const up_next = <UpNextWrapper><UpNextText>up next</UpNextText></UpNextWrapper>;

        return <div>
            <InfoBlock>
                {now_playing}
                {video_title}
                {video_materials}
                {video_comment}
                <DetailsWrapper>
                    {video_date}
                    {video_venue}
                    {video_location}
                </DetailsWrapper>
                {video_code}
            </InfoBlock>
            {up_next}
        </div>;
    }
}

export default VideoInfoBlock;
